import AXIOS from 'axios';
import Parameters from 'shared/parameters';
import { getAuthToken } from '../contexts/AuthContext';

function getPublicInstance() {
    const headers = {
        'X-localization': localStorage.getItem('language') || Parameters.DefaultLang,
        'CUSTOM-REFERRER': Parameters.CustomReferrer || window.location.host,
    };
    return AXIOS.create({
        // @ts-ignore
        'accept': 'application/json',
        'baseURL': Parameters.ApiUrl + '/',
        'headers': {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers,
        },
    });
}

function getGLOBALPublicInstance() {
    console.log(Parameters)
    const headers = {
        'X-localization': localStorage.getItem('language') || Parameters.DefaultLang,
        'CUSTOM-REFERRER': Parameters.CustomReferrer || window.location.host,
    };
    return AXIOS.create({
        // @ts-ignore
        'accept': 'application/json',
        'baseURL': Parameters.ApiUrl.replace('/admin', '') + '/',
        'headers': {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers,
        },
    });
}

function getProtectedInstance(addAuth = false) {
    const headers: any = {
        'X-localization': localStorage.getItem('language') || Parameters.DefaultLang,
        'CUSTOM-REFERRER': Parameters.CustomReferrer || window.location.host,
    };
    const token = localStorage.getItem('auth-token');
    if (token) {
        headers['Authorization'] = `Bearer ${JSON.parse(token as string).access_token}`;
    }
    return AXIOS.create({
        // @ts-ignore
        'accept': 'application/json',
        'baseURL': Parameters.ApiUrl + (addAuth && token ? '/auth/' : '/'),
        'headers': {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers,
        },
    });
}
function getProtectedInstanceNoAPI(addAuth = false) {
    const headers: any = {
        'X-localization': localStorage.getItem('language') || Parameters.DefaultLang,
        'CUSTOM-REFERRER': Parameters.CustomReferrer || window.location.host,
    };
    const token = localStorage.getItem('auth-token');
    if (token) {
        headers['Authorization'] = `Bearer ${JSON.parse(token as string).access_token}`;
    }
    return AXIOS.create({
        // @ts-ignore
        'accept': 'application/json',
        'baseURL': (Parameters.ApiUrl + (addAuth && token ? '/auth/' : '/')).replace('/api', ''),
        'headers': {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers,
        },
    });
}

function getInstanceFile(addAuth = false) {
    const headers: any = {
        'X-localization': localStorage.getItem('language') || Parameters.DefaultLang,
        'CUSTOM-REFERRER': Parameters.CustomReferrer || window.location.host,
    };
    const token = localStorage.getItem('auth-token');
    if (token) {
        headers['Authorization'] = `Bearer ${JSON.parse(token as string).access_token}`;
    }
    return AXIOS.create({
        // @ts-ignore
        'accept': 'application/json',
        'baseURL': Parameters.ApiUrl + (addAuth && token ? '/auth/' : '/'),
        'headers': {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
            ...headers,
        },
    });
}

function handleErrors(error: any) {
    let message = 'Something went wrong!!';
    if (error && error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
    } else if (error && error.response && error.response.data && error.response.data.errors) {
        let e = [];
        for (let i in error.response.data.errors) {
            e.push(`${i}: ${error.response.data.errors[i]}`);
        }
        message = e.join(',');
    }
    return message;
}

async function login(email: string, password: string) {
    const instance = getPublicInstance();
    return await instance.post('login', { email, password });
}

async function fetchSettings() {
    const instance = getPublicInstance();
    return await instance.get('settings');
}

async function fetchBanners() {
    const instance = getPublicInstance();
    return await instance.get('banners');
}

async function fetchCourses(params: any = {}) {
    const instance = getProtectedInstance(true);
    return await instance.get('courses', { params });
}

async function fetchFavouriteCourses(params: any = {}) {
    const instance = getProtectedInstance(true);
    return await instance.get('users/wishlist', { params });
}

async function fetchMyCourses(params: any = {}) {
    const instance = getProtectedInstance(true);
    return await instance.get('users/courses?is_self=true', { params });
}

async function fetchCourseById(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.get('courses/' + id);
}

async function fetchCourseByIdAdminEnd(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get('content-management/courses/show/' + id);
}

async function fetchMeetingsByCourseId(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.get('courses/' + id + '/meetings');
}

async function fetchInsCourse() {
    const instance = getProtectedInstance(true);
    return await instance.get('users/instructor_courses');
}

async function fetchDraftCourseAdmin() {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get('content-management/courses/draft');
}

async function fetchUploadedVideo(course_id : any, module_id : any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${course_id}/curriculums/${module_id}/contents/uploadedVideos`);
}

async function fetchDraftCourseInstructor() {
    const instance = getProtectedInstance(true);
    return await instance.get('content-management/courses/draft');
}

async function fetchContentById(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.get('courses/' + id + `/contents/${id}`);
}

async function fetchContentByIdAdminEnd(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get('/content-management/courses/' + id + `/contents/${id}`);
}

async function fetchCourseReviewsByCourseId(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`courses/${id}/reviews`);
}

async function fetchInsReviewsByUserId(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`instructor-ratings/${id}`);
}

async function fetchCart() {
    const instance = getProtectedInstance(true);
    return await instance.get('cart');
}

async function me() {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get('users/me');
}

async function insCourseReport() {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get('users/me/course-report');
}

async function fetchStaticPageByPath(path: string) {
    const instance = getGLOBALPublicInstance();
    return await instance.get('pages/get-by-path/' + path);
}

async function markCourseNotFav(courseId: any) {
    const instance = getProtectedInstance(true);
    return await instance.delete('users/wishlist/' + courseId);
}

async function updateProfile(profileData: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.put('users/me', profileData);
}

async function updateOrgProfile(profileData: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.put('users/me/organization', profileData);
}

const mediaUpload = (formData: any) => {
    const instance = getInstanceFile(Parameters.Mode === 'CLIENT');
    return instance.post('media', formData);
};

const scormUpload = (formData: any) => {
    const instance = getInstanceFile(Parameters.Mode === 'CLIENT');
    return instance.post('content-management/courses/scorm-upload', formData);
};

const submitQuiz = (data: any, courseId: any, contentId: any) => {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return instance.post('courses/' + courseId + `/contents/${contentId}/quiz-submission`, data);
};


const htmlUpload = (courseId: any, curriculumId: any, formData: any) => {
    const instance = getInstanceFile(Parameters.Mode === 'CLIENT');
    return instance.post(`content-management/courses/${courseId}/curriculums/${curriculumId}/html-upload`, formData);
};

async function markFavourite(courseId: any) {
    const instance = getProtectedInstance(true);
    return await instance.post('users/wishlist', { course_id: courseId });
}
async function certificate(courseId: any) {
    const instance = getProtectedInstance(true);
    return await instance.get('users/courses/' + courseId);
}

async function submitReview({ courseId, ...data }: any) {
    const instance = getProtectedInstance(true);
    return await instance.post(`courses/${courseId}/reviews`, data);
}

async function addToCart(data: any) {
    const instance = getProtectedInstance(true);
    return await instance.post(`cart`, data);
}

async function createOrder() {
    const instance = getProtectedInstance(true);
    return await instance.post(`checkout/initiate`);
}

async function completePurchase(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`payment/paypal/capture`, data);
}

async function createOrderPayPal(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.post(`checkout/place/${id}/paypal`);
}

async function removeFromCart(id: any) {
    const instance = getProtectedInstance(true);
    return await instance.delete(`cart/${id}`);
}

async function subscribeCourse(courseId: any) {
    const instance = getProtectedInstance(true);
    return await instance.post(`checkout/subscribe/${courseId}`);
}

async function getOrders() {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/orders?per_page=1000`);
}

async function getStudentList(params:any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/me/sold?per_page=1000`,{params});
}

async function getMyMeetings(params: any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/me/upcoming-meetings`, {params});
}

async function myReviews() {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/reviews?per_page=1000`);
}
async function myInsReviews() {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/instructor-reviews`);
}
async function insReviews() {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/me/instructor-reviews`);
}
async function insOwnReviews() {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/me/instructor-self-reviews`);
}
async function getMyBadges(params: any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/badges?per_page=1000`,{params});
}

async function fetchOrganizations(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`organizations`, { params });
}

async function fetchUsers(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`users`, { params });
}

async function fetchBadges(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`badges`, { params });
}

async function fetchBannersAdmin(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`banners`, { params });
}

async function fetchPackagesAdmin(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`packages`, { params });
}

async function fetchStaticPagesAdmin(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`pages`, { params });
}

async function fetchCategoriesAdmin(params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/categories`, { params });
}

async function fetchSubCategoriesAdmin(parent_id : any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/categories/child/${parent_id}`);
}

async function fetchSubCategoryAdmin(data : any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/categories/child/list`,data);
}

async function fetchLevelsAdmin(params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/levels`, { params });
}

async function fetchCoursesAdmin(params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses`, { params });
}


async function fetchCurriculumsAdmin(courseId: any, params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/curriculums`, { params });
}

async function fetchQuestionsAdmin(courseId: any, curriculumId: any, contentId: any, params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${contentId}/questions`, { params });
}

async function fetchMeetingsAdmin(courseId: any, params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/meetings`, { params });
}

async function fetchContentsAdmin(courseId: any, curriculumId: any, params: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents`, { params });
}

async function fetchSCORMUrl(courseId: any, curriculumId: any, id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`courses/${courseId}/curriculums/${curriculumId}/contents/${id}/sco`);
}


async function fetchReviewsAdmin(params: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`reviews`, { params });
}
async function fetchInsRatingAdmin() {
    const instance = getProtectedInstance(false);
    return await instance.get(`instructor-ratings`);
}

async function fetchOrganizationById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`organizations/${id}`);
}

async function fetchUserById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`users/${id}`);
}

async function fetchBadgeById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`badges/${id}`);
}

async function fetchBannerById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`banners/${id}`);
}

async function fetchPackageById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`packages/${id}`);
}

async function fetchStaticPageById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`pages/${id}`);
}

async function fetchCategoryById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`content-management/categories/${id}`);
}

async function fetchLevelById(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`content-management/levels/${id}`);
}

async function fetchCourseByIdAdmin(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${id}`);
}

async function createCourseSchedule(reqObj: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.post(`content-management/schedules/store`,reqObj);
}

async function fetchCourseScheduleAdmin(reqObj: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/schedules`,reqObj);
}

async function fetchCourseSchedule(reqObj: any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`users/schedules`,reqObj);
}

async function fetchCurriculumByIdAdmin(courseId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/curriculums/${id}`);
}

async function fetchQuestionByIdAdmin(courseId: any, curriculumId: any, contentId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${contentId}/questions/${id}`);
}

async function fetchMeetingByIdAdmin(courseId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/meetings/${id}`);
}

async function fetchContentByIdAdmin(courseId: any, curriculumId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${id}`);
}

async function createOrganization(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`organizations`, data);
}

async function updateOrganization(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`organizations/${id}`, data);
}

async function createCourseComplete(courseId: any,contentId: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`auth/users/courses/complete`, {course_id:courseId, content_id:contentId});
}
async function courseAddProgress(courseId: any,contentId: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`auth/courses/${courseId}/contents/${contentId}/add-progress`);
}

async function createDraftCourseAdmin(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`content-management/courses/draft`, data);
}

async function createDraftCourseInstructor(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`auth/content-management/courses/draft`, data);
}

async function createUser(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`users`, data);
}

async function createBadge(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`badges`, data);
}

async function createBanner(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`banners`, data);
}

async function createPackage(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`packages`, data);
}

async function createCategories(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`content-management/categories`, data);
}

async function createLevel(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`content-management/levels`, data);
}

async function createCourse(data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.post(`content-management/courses`, data);
}

async function createCurriculum(courseId: any, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.post(`content-management/courses/${courseId}/curriculums`, data);
}


async function createQuestion(courseId: any, curriculumId: any, contentId: any, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.post(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${contentId}/questions`, data);
}

async function updateQuestion(courseId: any, curriculumId: any, contentId: any, quesId: any, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.put(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${contentId}/questions/${quesId}`, data);
}

async function createMeeting(courseId: any, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.post(`content-management/courses/${courseId}/meetings`, data);
}


async function createContent(courseId: any, curriculumId: any, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.post(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents`, data);
}

async function resetStaticPages() {
    const instance = getProtectedInstance(false);
    return await instance.post(`pages/create_default_pages?is_reset`);
}

async function updateUser(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`users/${id}`, data);
}

async function updateBadge(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`badges/${id}`, data);
}

async function updateBanner(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`banners/${id}`, data);
}

async function updatePackage(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`packages/${id}`, data);
}

async function updateCategories(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`content-management/categories/${id}`, data);
}

async function updateLevel(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`content-management/levels/${id}`, data);
}

async function updateCourse(id: number, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.put(`content-management/courses/${id}`, data);
}

async function updateCurriculum(courseId: any, id: number, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.put(`content-management/courses/${courseId}/curriculums/${id}`, data);
}


async function updateContent(courseId: any, curriculumId: any, id: number, data: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.put(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${id}`, data);
}

async function updateStaticPage(id: number, data: any) {
    const instance = getProtectedInstance(false);
    return await instance.put(`pages/${id}`, data);
}

async function fetchReports(params: any, type: string) {
    const instance = getProtectedInstance(false);
    if (!params['filter_organization_id']) {
        delete params['filter_organization_id'];
    }
    delete params['total'];
    return await instance.get(`reports/${type}`, { params });
}

async function fetchContentReports(data:any, course_id: any, student_id: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`reports/contents?course_id=${course_id}&student_id=${student_id}`,data);
}

async function fetchwrongQuestionsReport() {
    const instance = getProtectedInstance(false);
    return await instance.get(`reports/wrong-questions`);
}

async function register(data: any) {
    const instance = getPublicInstance();
    return await instance.post('signup', data);
}

async function resetPassword(data: any) {
    const instance = getPublicInstance();
    return await instance.post('password/reset', data);
}

async function createResetPasswordToken(data: any) {
    const instance = getPublicInstance();
    return await instance.post('password/token', data);
}

async function fetchCategories(data: any) {
    const instance = getPublicInstance();
    return await instance.get('categories', data);
}

async function courseClickCount(courseId: any, userId: any) {
    const instance = getPublicInstance();
    return await instance.post(`courses/${courseId}/add-click-count`, userId);
}
async function fetchSubCategoriesCourses(data: any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`auth/categories-tree?courseForm=${true}`, data);
}
async function fetchSubCategories(data: any) {
    const instance = getPublicInstance();
    return await instance.get(`categories-tree`, data);
}

async function fetchLevels(data: any) {
    const instance = getPublicInstance();
    return await instance.get('levels', data);
}
async function setInstructorRating(instructorId:any,data: any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`auth/instructor-ratings/${instructorId}`, data);
}
async function removeOrganization(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`organizations/${id}`);
}

async function removeUser(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`users/${id}`);
}

async function removeBadge(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`badges/${id}`);
}

async function removeBanner(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`banners/${id}`);
}

async function removePackage(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`packages/${id}`);
}

async function removeCategories(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`content-management/categories/${id}`);
}

async function removeLevel(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`content-management/levels/${id}`);
}

async function removeCourse(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.delete(`content-management/courses/${id}`);
}

async function removeCurriculum(courseId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.delete(`content-management/courses/${courseId}/curriculums/${id}`);
}

async function removeQuestion(courseId: any, curriculumId: any, contentId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.delete(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${contentId}/questions/${id}`);
}

async function removeMeeting(courseId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.delete(`content-management/courses/${courseId}/meetings/${id}`);
}

async function joinMeeting(courseId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.get(`content-management/courses/${courseId}/meetings/${id}/join`);
}

async function joinMeetingClient(courseId: any, id: any) {
    const instance = getProtectedInstance(true);
    return await instance.get(`courses/${courseId}/meetings/${id}/join`);
}

async function removeContent(courseId: any, curriculumId: any, id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.delete(`content-management/courses/${courseId}/curriculums/${curriculumId}/contents/${id}`);
}

async function activateReview(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`reviews/${id}/activate`);
}

async function deactivateReview(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`reviews/${id}/deactivate`);
}

async function activateCategory(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`content-management/categories/${id}/activate`);
}

async function activateLevel(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`content-management/levels/${id}/activate`);
}

async function activateCourse(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`content-management/courses/${id}/activate`);
}

async function deactivateUser(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`users/${id}/deactivate`);
}
async function activateUser(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`users/${id}/activate`);
}
async function activateBadge(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`badges/${id}/activate`);
}
async function deactivateBadge(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`badges/${id}/deactivate`);
}
async function activateBanner(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`banners/${id}/activate`);
}
async function deactivateBanner(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`banners/${id}/deactivate`);
}
async function activatePackage(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`packages/${id}/activate`);
}
async function deactivatePackage(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`packages/${id}/deactivate`);
}

async function deactivateCategory(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`content-management/categories/${id}/deactivate`);
}

async function deactivateLevel(id: any) {
    const instance = getProtectedInstance(false);
    return await instance.patch(`content-management/levels/${id}/deactivate`);
}

async function deactivateCourse(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`content-management/courses/${id}/deactivate`);
}

async function activateInsRating(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`instructor-ratings/${id}/activate`);
}
async function deactivateInsRating(id: any) {
    const instance = getProtectedInstance(Parameters.Mode === 'CLIENT');
    return await instance.patch(`instructor-ratings/${id}/deactivate`);
}

async function fetchPackages() {
    const instance = getPublicInstance();
    return await instance.get('packages');
}

async function fetchTeachers({per_page} : any) {
    const instance = getPublicInstance();
    return await instance.get(`instructors?per_page=${per_page}`);
}

async function fetchHomeStats() {
    const instance = getProtectedInstance(false);
    return await instance.get(`home-stats`);
}

async function setVideoCurrTime(data : any) {
    const instance = getProtectedInstance(false);
    return await instance.post(`auth/users/currenttime/set`,data);
}

async function getVideoCurrTime(contentId : any) {
    const instance = getProtectedInstance(false);
    return await instance.get(`auth/users/currenttime/get?content_id=${contentId}`);
}

const API_SERVICE = {
    fetchPackages,
    fetchTeachers,
    login,
    setVideoCurrTime,
    getVideoCurrTime,
    register,
    resetPassword,
    createResetPasswordToken,
    me,
    insCourseReport,
    fetchStaticPageByPath,
    fetchSettings,
    fetchCart,
    updateProfile,
    mediaUpload,
    fetchBanners,
    fetchCourses,
    fetchFavouriteCourses,
    fetchMyCourses,
    fetchCourseById,
    fetchCourseByIdAdminEnd,
    fetchContentById,
    fetchContentByIdAdminEnd,
    fetchCourseReviewsByCourseId,
    fetchInsReviewsByUserId,


    fetchCategories,
    courseClickCount,
    fetchSubCategoriesCourses,
    fetchSubCategories,
    fetchLevels,
    setInstructorRating,


    markCourseNotFav,
    markFavourite,
    submitReview,
    addToCart,
    createOrder,
    completePurchase,
    createOrderPayPal,
    removeFromCart,
    subscribeCourse,
    getOrders,
    getStudentList,
    myReviews,
    myInsReviews,
    insReviews,
    insOwnReviews,
    getMyBadges,


    fetchOrganizations,
    fetchOrganizationById,
    createOrganization,
    updateOrganization,
    removeOrganization,
    fetchReports,
    fetchContentReports,
    fetchwrongQuestionsReport,

    createCourseComplete,

    courseAddProgress,

    createDraftCourseAdmin,
    createDraftCourseInstructor,

    fetchUserById,
    fetchUsers,
    createUser,
    updateUser,
    removeUser,
    activateUser,
    deactivateUser,

    fetchBadgeById,
    fetchBadges,
    createBadge,
    updateBadge,
    removeBadge,
    activateBadge,
    deactivateBadge,
    


    fetchBannerById,
    fetchBannersAdmin,
    createBanner,
    updateBanner,
    removeBanner,
    activateBanner,
    deactivateBanner,


    fetchPackageById,
    fetchPackagesAdmin,
    createPackage,
    updatePackage,
    removePackage,
    activatePackage,
    deactivatePackage,


    fetchStaticPageById,
    fetchStaticPagesAdmin,
    resetStaticPages,
    updateStaticPage,

    fetchReviewsAdmin,
    fetchInsRatingAdmin,


    fetchCategoryById,
    fetchCategoriesAdmin,
    fetchSubCategoriesAdmin,
    fetchSubCategoryAdmin,
    createCategories,
    updateCategories,
    removeCategories,
    activateCategory,
    deactivateCategory,

    fetchLevelById,
    fetchLevelsAdmin,
    createLevel,
    updateLevel,
    removeLevel,
    activateLevel,
    deactivateLevel,

    fetchCourseByIdAdmin,
    createCourseSchedule,
    fetchCourseScheduleAdmin,
    fetchCourseSchedule,
    fetchCoursesAdmin,
    createCourse,
    updateCourse,
    removeCourse,
    activateCourse,
    deactivateCourse,
    activateInsRating,
    deactivateInsRating,

    fetchCurriculumByIdAdmin,
    fetchCurriculumsAdmin,
    createCurriculum,
    updateCurriculum,
    removeCurriculum,


    fetchQuestionByIdAdmin,
    fetchQuestionsAdmin,
    createQuestion,
    updateQuestion,
    removeQuestion,


    fetchMeetingByIdAdmin,
    fetchMeetingsAdmin,
    createMeeting,
    removeMeeting,
    joinMeeting,


    fetchContentByIdAdmin,
    fetchContentsAdmin,
    fetchSCORMUrl,
    createContent,
    updateContent,
    removeContent,
    scormUpload,
    submitQuiz,
    htmlUpload,

    fetchMeetingsByCourseId,
    fetchInsCourse,
    fetchDraftCourseAdmin,
    fetchUploadedVideo,
    fetchDraftCourseInstructor,
    joinMeetingClient,
    getMyMeetings,
    handleErrors,
    updateOrgProfile,
    deactivateReview,
    activateReview,
  certificate,

  fetchHomeStats
};
export default API_SERVICE;
